import script from "./jtjj.vue?vue&type=script&setup=true&lang=js"
export * from "./jtjj.vue?vue&type=script&setup=true&lang=js"

import "./jtjj.vue?vue&type=style&index=0&id=84477aec&lang=less&scoped=true"

import exportComponent from "C:\\Users\\An\\Documents\\WeChat Files\\wxid_s0kqbotfa70022\\FileStorage\\File\\2024-08\\pzh_develop_website发展集团官网\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84477aec"]])

export default __exports__